export default "__VITE_PUBLIC_ASSET__84204372__"